import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';
import { Link } from 'gatsby';

import ExternalLinkIcon from '~components/common/ExternalLinkIcon';

import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';

export default function PollingPlaceRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');
  const pollingPlaceURL = stateData.gov_tool_polling_place.text;

  return (
    <TableRow>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'Polling place locator',
            valueNode: (
              <div>
                {pollingPlaceURL ? (
                  <Link
                    to={pollingPlaceURL}
                    target='_blank'
                    rel='noopener'
                    title={`${stateName} polling place locator`}
                  >
                    {stateName} polling place locator
                    <ExternalLinkIcon />
                  </Link>
                ) : (
                  'N/A'
                )}
              </div>
            ),
          },
        ]}
      />
    </TableRow>
  );
}
PollingPlaceRowRenderer.propTypes = rowRendererProps;
